import { useResetTenantOnboardingSkipMutation } from 'api/Common/mutation';
import { usePersistBillsFilterMutation } from 'pages/Bills/List/api/mutation';
import { IBillsUserPersistPostBody } from 'pages/Bills/List/types';
import { Logger } from 'utils/logger';
import { clearAuthSessionStorage } from 'utils/sessionIdle';

const CLEAR_BILLS_PERSIST_PAYLOAD: IBillsUserPersistPostBody = {
  data: { web: { bills: {} }, mobile: {} },
} as IBillsUserPersistPostBody;

export const useLogout = () => {
  const { mutateAsync: resetTenantOnboardingSkipAsync } =
    useResetTenantOnboardingSkipMutation();
  const { mutateAsync: clearBillsUserPersistAsync } =
    usePersistBillsFilterMutation();

  const logout = async () => {
    // Run both cleanup calls in parallel so logout latency is bounded by the
    // slower of the two, not their sum. Both are best-effort — failures are
    // logged but never block the redirect.
    const [billsResult, onboardingResult] = await Promise.allSettled([
      clearBillsUserPersistAsync(CLEAR_BILLS_PERSIST_PAYLOAD),
      resetTenantOnboardingSkipAsync(),
    ]);

    if (billsResult.status === 'rejected') {
      Logger.error({
        message: 'Error clearing bills user-persist on logout',
        data: billsResult.reason,
      });
    }
    if (onboardingResult.status === 'rejected') {
      Logger.error({
        message: 'Error resetting tenant onboarding skip flag',
        data: onboardingResult.reason,
      });
    }

    clearAuthSessionStorage();
    sessionStorage.clear();
    window.location.assign('/login');
  };

  return { logout };
};
